import React from 'react';
import { Button } from 'components/shadcn/ui/button';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';

export const COMPANIES_LIST_LIMIT = 1000;
export const COMPANY_PAGE_SIZE = 20;
export const columns = [
    {
        Header: 'ID',
        accessor: 'ID',
        component: (item) => (
            <div className="flex">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => navigator.clipboard.writeText(item.ID)}
                    className="mr-2"
                >
                    <ClipboardDocumentIcon className="w-4 h-4" />
                </Button>
                <p className="text-sm">{item.ID}</p>
            </div>
        ),
    },
    {
        Header: 'Company Name',
        accessor: 'Name',
    },
    {
        Header: 'Contact Email',
        accessor: 'Email',
    },
    {
        Header: 'Address',
        accessor: 'Address',
    },
];
